import { Directive, ElementRef, Input, Inject, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

import * as Feather from 'feather-icons';

@Directive({
    selector: '[data-feather]',
    standalone: false
})
export class FeatherIconDirective implements OnChanges {
  // Private
  private _renderedElement: Element | null = null;

  @Input('data-feather') name!: string;
  @Input() class!: string;
  @Input() size!: string;
  @Input() inner!: boolean;

  /**
   * Constructor
   *
   * @param {ElementRef} _elementRef
   */
  constructor(
    @Inject(ElementRef) private _elementRef: ElementRef,
    @Inject(ChangeDetectorRef) private _changeDetector: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // SVG parameter
    this.name = changes.name ? changes.name.currentValue : this.name;
    this.size = changes.size ? changes.size.currentValue : '14'; // Set default size 14
    this.class = changes.class ? changes.class.currentValue : '';

    // Create SVG
    const svg = Feather.icons[this.name].toSvg({
      class: this.class,
      width: this.size,
      height: this.size
    });

    const nativeEl: Element = this._elementRef.nativeElement;

    // Set SVG
    if (this.inner) {
      nativeEl.innerHTML = svg;
    } else {
      // targetEl: el SVG ya renderizado o el elemento original si es la primera vez
      const targetEl = this._renderedElement || nativeEl;
      const parent = targetEl.parentNode;
      if (parent) {
        const temp = document.createElement('div');
        temp.innerHTML = svg;
        const svgEl = temp.firstChild as Element;
        parent.replaceChild(svgEl, targetEl);
        this._renderedElement = svgEl;
      }
    }
    this._changeDetector.markForCheck();
  }
}
